module.exports = __webpack_public_path__ + "img/Arnold.a31f34b1.png";